// Trade utility functions to eliminate duplication

export const calculateTradeMetrics = (entryPrice, stopLoss, exitPrice, positionSize, leverage) => {
  const ep = parseFloat(entryPrice);
  const sl = parseFloat(stopLoss);
  const tp = parseFloat(exitPrice);
  const size = parseFloat(positionSize);
  const lev = parseFloat(leverage);
  
  if (!ep || !sl || !tp || !size || !lev) return {};
  
  const risk = Math.abs(ep - sl);
  const reward = Math.abs(tp - ep);
  const qty = (size * lev) / ep;
  const riskAmt = risk * qty;
  const rewardAmt = reward * qty;
  
  // Calculate the ratio as a proper ratio (e.g., 1:2)
  const rawRatio = rewardAmt / riskAmt;
  const gcd = (a, b) => b ? gcd(b, a % b) : a;
  const ratioGcd = gcd(Math.round(rawRatio * 100), 100);
  const numerator = 1;
  const denominator = Math.round((rawRatio * 100) / ratioGcd) / (100 / ratioGcd);
  
  return {
    riskAmount: riskAmt.toFixed(2),
    rewardAmount: rewardAmt.toFixed(2),
    quantity: qty.toFixed(2),
    riskRewardRatio: (rewardAmt / riskAmt).toFixed(2),
    riskRewardRatioFormatted: `1:${denominator.toFixed(1)}`.replace('.0', '')
  };
};

export const calculatePnL = (status, metrics) => {
  switch (status) {
    case 'WIN': return metrics.rewardAmount;
    case 'LOSS': return `-${metrics.riskAmount}`;
    case 'BREAKEVEN': return '0';
    default: return '';
  }
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.readAsDataURL(file);
  });
};

export const processImageFile = async (file, setImageFile, setPreviewUrl, setScreenshotBase64) => {
  setImageFile(file);
  setPreviewUrl(URL.createObjectURL(file));
  const base64 = await convertFileToBase64(file);
  setScreenshotBase64(base64);
};